import { Container } from "@mui/material";
import BazarImage from "components/BazarImage";
import CategorySectionHeader from "components/CategorySectionHeader";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { H4, Paragraph } from "components/Typography";

const FrequentlyAskQuestion = () => {
  return (
    <ShopLayout1 title="Frequently Asked Questions" navbar={<Navbar />}>
      <Container maxWidth="lg" sx={{ p: 2 }}>
        <CategorySectionHeader title="Frequently Asked Question" />
        <BazarImage
          alt="faq"
          src="/assets/images/banners/frequently-asked-questions.png"
          sx={{ width: "100%", mt: 2 }}
        />
        <H4 mt={3}>What are the payment options</H4>
        <Paragraph>Available payment option are:</Paragraph>
        <ol>
          <li>Cash on delivery</li>
          <li>Direct Gcash transfer</li>
          <li>Direct Bank Transfer via BDO</li>
          <li>Credit/Debit Visa Card via Paymongo</li>
        </ol>
        <H4 mt={3}>Can you deliver item(s) outside Metro Manila?</H4>
        <Paragraph>
          Yes, we offer nationwide delivery through our logistic partner.
        </Paragraph>
        <H4 mt={3}>How do I receive my order?</H4>
        <Paragraph>
          Orders can be received via delivery or store pick-up.
        </Paragraph>
        <H4 mt={3}>How to track my order?</H4>
        <Paragraph>
          You can track your order from our customer support through calls or
          via Facebook page chat.
        </Paragraph>
        <H4 mt={3}>Can I return an item?</H4>
        <Paragraph>
          NO, because we&apos;re implementing <strong>No Return Policy.</strong>
        </Paragraph>
        <Paragraph>
          YES, when the product is proven defective by our tech.
        </Paragraph>
        <H4 mt={3}>Do you have refund?</H4>
        <Paragraph>Unfortunately, we don&apos;t have cash refund.</Paragraph>
        <H4 mt={3}>Do you have installments?</H4>
        <Paragraph mb={10}>Yes, we have installments via Paymongo</Paragraph>
      </Container>
    </ShopLayout1>
  );
};

export default FrequentlyAskQuestion;
